var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { MediaCarousel } from '@inter-ikea-kompis/component-media-carousel';
/**
 * The view for the Summary Page Images.
 *
 * @event change Triggered when the user changes to a new image
 */
export default class SummaryPageImages extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // List of media items
        this.images = null;
        // Index of the current main image
        this.selectedImageIndex = 0;
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html ` ${this.getMediaCarousel()} `;
    }
    connectedCallback() {
        this.customElements.define('kompis-media-carousel', MediaCarousel);
        super.connectedCallback();
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation;
    }
    /**
     * Get Media Carousel. When images prop is undefined, the carousel is not shown.
     *
     * @returns The store selector.
     */
    getMediaCarousel() {
        if (!this.images) {
            return null;
        }
        // Fallback to first image if selected image is out of range.
        if (this.selectedImageIndex >= this.images.length) {
            this.selectedImageIndex = 0;
        }
        return html ` <kompis-media-carousel
			.localizedInformation="${this.localizedInformation}"
			.translations="${this.translations}"
			.theme="${this.theme}"
			.selectedIndex="${this.selectedImageIndex}"
			.mediaItems="${this.images}"
			.showScrollbar="${true}"
			.showArrows="${true}"
			@change="${({ detail }) => {
            this.selectedImageIndex = detail.selectedIndex;
            this.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
                detail: { selectedIndex: detail.selectedIndex }
            }));
            this.requestUpdate();
        }}"
		></kompis-media-carousel>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], SummaryPageImages.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], SummaryPageImages.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], SummaryPageImages.prototype, "translations", void 0);
__decorate([
    property({ type: Object })
], SummaryPageImages.prototype, "images", void 0);
//# sourceMappingURL=SummaryPageImages.js.map